import { Box, Checkbox, CheckboxGroup, Flex, Stack } from "@chakra-ui/react";
import { ResponsiveBar } from "@nivo/bar";
import * as React from "react";
import { useEffect } from "react";
import { getFormattedNumValue, numberFormatter } from "../../../../utils";

const CarbonIntensityGraph = ({ data, years }) => {
  const [graphData, setGraphData] = React.useState([]);

  useEffect(() => {
    const transformedData = data?.map((el) => {
      const transformedEntry = { supplier: el.supplierName };
      years.forEach((year) => {
        transformedEntry[year] = el?.yearlyEmissionData?.[year]?.intensity || 0;
      });
      return transformedEntry;
    });

    setGraphData(transformedData);
  }, [data, years]);

  const chartHeight = Math.max(600, graphData?.length * 30); // min 200px

  return (
    <Flex display={"block"} height={`${chartHeight}px`} width={"100%"}>
      <Box mt={8}></Box>

      <ResponsiveBar
        data={graphData}
        keys={years}
        indexBy="supplier"
        layout="horizontal"
        groupMode="grouped"
        margin={{ top: 50, right: 130, bottom: 50, left: 200 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={{ scheme: "nivo" }} // or create a custom color scheme
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "tCO2e",
          legendPosition: "middle",
          legendOffset: 32,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        animate={true}
        motionConfig="wobbly"
        valueFormat={(value) => `${getFormattedNumValue(value)}`}
      />
    </Flex>
  );
};

export default CarbonIntensityGraph;
